'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _pipeWith = require('./util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

var _delete = require('./delete');

var _delete2 = _interopRequireDefault(_delete);

var _keyArray = require('./keyArray');

var _keyArray2 = _interopRequireDefault(_keyArray);

var _last = require('./last');

var _last2 = _interopRequireDefault(_last);

var _pop = require('./pop');

var _pop2 = _interopRequireDefault(_pop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyed = function keyed() {
    return function (value) {
        return (0, _pipeWith2.default)(value, (0, _delete2.default)((0, _pipeWith2.default)(value, (0, _keyArray2.default)(), (0, _last2.default)())));
    };
};

exports.default = (0, _prep2.default)({
    name: 'butLast',
    immutable: 'butLast',
    record: keyed,
    object: keyed,
    array: _pop2.default
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/butLast.js
// module id = 897
// module chunks = 35783957827783